type ListRow = unknown[];

const listsData: Record<number, ListRow[]> = {};

const cloneRow = (row: unknown): ListRow =>
    Array.isArray(row) ? [...row] : [row];

export const initMemoryLists = (lists: Array<{ id: number; data?: unknown[] }> = []) => {
    Object.keys(listsData).forEach((key) => {
        delete listsData[Number(key)];
    });

    lists.forEach((list) => {
        listsData[list.id] = Array.isArray(list.data)
            ? list.data.map((row) => cloneRow(row))
            : [];
    });
};

export const ensureListExists = (listId: number) => {
    if (!listsData[listId]) {
        listsData[listId] = [];
    }
};

export const registerNewList = (listId: number) => {
    ensureListExists(listId);
};

export const getListData = (listId: number): ListRow[] => {
    ensureListExists(listId);
    return listsData[listId];
};

export const getListClone = (listId: number): ListRow[] =>
    getListData(listId).map((row) => cloneRow(row));

export const setListData = (listId: number, data: ListRow[] = []) => {
    listsData[listId] = data.map((row) => cloneRow(row));
};

export const appendToList = (listId: number, items: ListRow[] = []) => {
    const list = getListData(listId);

    items.forEach((item) => {
        list.push(cloneRow(item));
    });

    return list.length;
};

export const clearList = (listId: number) => {
    listsData[listId] = [];
    return 0;
};

export const getListSize = (listId: number) => getListData(listId).length;

export const getListsSnapshot = (): Record<number, ListRow[]> => {
    const snapshot: Record<number, ListRow[]> = {};

    Object.keys(listsData).forEach((key) => {
        const id = Number(key);
        snapshot[id] = getListClone(id);
    });

    return snapshot;
};

export const applyListsSnapshot = (snapshot: Record<number, ListRow[]> = {}) => {
    if (!snapshot || typeof snapshot !== 'object') {
        return;
    }

    Object.keys(snapshot).forEach((key) => {
        const id = Number(key);
        setListData(id, snapshot[id] ?? []);
    });
};

export const removeList = (listId: number) => {
    delete listsData[listId];
};

export const syncResultListFromMemory = (
    lists: Array<{ id: number; type?: number; name?: string; excludeAfterUse?: boolean }>
) =>
    lists.map((list) => ({
        id: list.id,
        type: list.type,
        name: list.name,
        excludeAfterUse: list.excludeAfterUse ?? false,
        qtd: getListSize(list.id),
    }));
